import React, { FunctionComponent, MouseEvent } from 'react';
import cls from '../utils/classnames';
import { ALERT, ALERT_BODY, ALERT_BUTTON, ALERT_BUTTON_CLOSE, ALERT_INFO } from '../utils/classes';
import './_styles.scss';
import { ColoredButton } from '../ColoredButton';

export interface IAlertProps {
  /**
   * message to display in alert
   */
  children: string | React.ReactElement;
  /**
   * optional className to add to wrapper
   */
  className?: string;
  /**
   * If true a close button will be displayed with the alert.
   */
  dissmisible?: boolean;
  /**
   * callback to  executen then click the close button
   */
  onCloseClick?: (event: MouseEvent<{}>) => unknown;
  /**
   * callback to  executen then click the message
   */
  onOkClick?: () => void;
  /**
   * If true a component will showed.
   */
  visible?: boolean;
  /**
   * Text showed in Ok Button.
   */
  okButtonText: string;
  /**
   * Optional text showed in close Button.
   */
  closeButtonText?: string;
}

/**
 * A stylish alert with an optional button to close it.
 */
export const Alert: FunctionComponent<IAlertProps> = props => {
  const { children, className, dissmisible, visible, onCloseClick, onOkClick , okButtonText, closeButtonText} = props;
  return (
    <div className={cls(ALERT, ALERT_INFO, className, visible? 'visible': 'hide')}>
      <div
        className={cls(ALERT_BODY)}
      >
        {children}
      </div>
      <ColoredButton
        className={cls(ALERT_BUTTON, "focusable")}
        color="green"
        onClick={onOkClick}
      >
        {okButtonText}
      </ColoredButton>
      <div>

      </div>
      {dissmisible && (
        <ColoredButton
          className={cls(ALERT_BUTTON, ALERT_BUTTON_CLOSE, "focusable")}
          color="yellow"
          onClick={onCloseClick}
        >
          {closeButtonText?closeButtonText:''}
        </ColoredButton>
      )}
    </div>
  );
};

Alert.defaultProps = {
  dissmisible: false
};



// WEBPACK FOOTER //
// ./src/packages/components/lib/Alert/index.tsx